import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { Circles } from 'react-loader-spinner';
import emailjs from 'emailjs-com';

const ContactForm = ({options}) => {
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    // const submitHandler = async (e) => {
    //     e.preventDefault();
    //     if (validator.allValid()) {
    //       validator.hideMessages();
    //       setLoading(true);
    
    //       try {
    //         const result = await emailjs.send(
    //           process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
    //           process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
    //           {
    //             name: forms.name,
    //             email: forms.email,
    //             phone_number: forms.phone,
    //             subject: forms.subject,
    //             message: forms.message,
    //           },
    //           process.env.REACT_APP_EMAILJS_USER_ID || ''
    //         );
    
    //         console.log('Email sent:', result.text);
    //         setEmailSent(true);
    //         setForms({ name: '', email: '', subject: '', phone: '', message: '' });
    //       } catch (error) {
    //         console.error('Error sending email:', error);
    //       } finally {
    //         setLoading(false);
    //       }
    //     } else {
    //       validator.showMessages();
    //     }
    // };

    const submitHandler = async (e) => {
        e.preventDefault();
        if (validator.allValid()) {
          validator.hideMessages();
          setLoading(true);
      
          try {
            // Send to you (your main form handling)
            const result = await emailjs.send(
              process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
              process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
              {
                name: forms.name,
                email: forms.email,
                phone_number: forms.phone,
                subject: forms.subject,
                message: forms.message,
              },
              process.env.REACT_APP_EMAILJS_USER_ID || ''
            );
      
            console.log('Email sent to work email:', result.text);
            let messageBody = "Thank you for reaching out to us! We’ve received your message and will get back to you soon.";
      
            // Send confirmation to user
            const confirmation = await emailjs.send(
              process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
              process.env.REACT_APP_EMAILJS_CONFIRMATION_TEMPLATE_ID || '',
              {
                name: forms.name,
                email: forms.email,
                messageBody: messageBody
              },
              process.env.REACT_APP_EMAILJS_USER_ID || ''
            );
      
            console.log('Confirmation email sent to user:', confirmation.text);
      
            setEmailSent(true);
            setForms({ name: '', email: '', subject: '', phone: '', message: '' });
          } catch (error) {
            console.error('Error sending email:', error);
          } finally {
            setLoading(false);
          }
        } else {
          validator.showMessages();
        }
      };  

    return (
        <form onSubmit={submitHandler} className="contact-validation-active" >
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Name" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your Email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.phone}
                            type="phone"
                            name="phone"
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            placeholder="Your phone" />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <select
                            onBlur={changeHandler}
                            onChange={changeHandler}
                            value={forms.subject}
                            type="text"
                            name="subject">
                            {options.options.map((option, id) => (
                                <option key={id}>{option.text}</option>
                            ))}
                        </select>
                        {validator.message('subject', forms.subject, 'required')}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        onBlur={changeHandler}
                        onChange={changeHandler}
                        value={forms.message}
                        type="text"
                        name="message"
                        placeholder="Message">
                    </textarea>
                    {validator.message('message', forms.message, 'required')}
                </div>
            </div>
            <div className="submit-area">
                <button type="submit" className="theme-btn" disabled={loading}>
                    {loading ? <Circles ariaLabel="loading" color="#ffffff" height="24" width="24" /> : 'Submit Now'}
                </button>
                {emailSent && <p className="success-msg">Thanks! Your message has been sent.</p>}
            </div>
        </form >
    )
}

export default ContactForm;